// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1aXzm","emails":"CreateEditClinics_emails__1cdIC","emailTagLabel":"CreateEditClinics_emailTagLabel__vd5fS"};